module.exports = __webpack_public_path__ + "img/time-arrow-up.8ec2f9bb.svg";